import React, { useEffect, useState } from "react";
import { getDino, deleteDino } from "../api/dinosApi";
import { useParams, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const DinoDetail = () => {
  const { id } = useParams();
  const nav = useNavigate();
  const { token } = useAuth();

  const [dino, setDino] = useState(null);
  const [showConfirm, setShowConfirm] = useState(false);
  const [loading, setLoading] = useState(true);
  const [errorMsg, setErrorMsg] = useState(null);

  useEffect(() => {
    fetchDino();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const fetchDino = async () => {
    try {
      setLoading(true);
      setErrorMsg(null);

      const res = await getDino(id);
      setDino(res.data);
    } catch (err) {
      console.error("Error cargando dino:", err);
      setErrorMsg("No se pudo cargar el dinosaurio (ID inválido o no existe).");
      setDino(null);
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async () => {
    try {
      await deleteDino(id);
      alert("Dinosaurio eliminado");
      nav("/dinos");
    } catch (error) {
      console.error(error);
      alert("Error al eliminar dinosaurio");
    } finally {
      setShowConfirm(false);
    }
  };

  const handleEdit = () => {
    nav(`/admin/dinos/edit/${id}`, { state: { dino } });
  };

  if (loading) return <div className="text-center mt-4">Cargando...</div>;

  if (errorMsg) {
    return (
      <div className="container mt-4">
        <div className="alert alert-danger text-center">{errorMsg}</div>
        <div className="text-center">
          <button className="btn btn-success" onClick={() => nav("/dinos")}>
            Volver a la lista
          </button>
        </div>
      </div>
    );
  }

  if (!dino) return <div className="text-center mt-4">No hay datos.</div>;

  return (
    <div
      className="card shadow-sm p-4 mb-4"
      style={{
        maxWidth: "500px",
        margin: "30px auto",
        borderRadius: "12px",
        position: "relative",
      }}
    >
      {/* Botón eliminar SOLO si hay token */}
      {token && (
        <button
          className="btn btn-sm btn-danger"
          style={{ position: "absolute", top: "10px", right: "10px" }}
          onClick={() => setShowConfirm(true)}
          title="Eliminar"
        >
          ×
        </button>
      )}

      <div className="card-body">
        <h3 className="card-title mb-4 text-center">{dino.name}</h3>

        <div className="mb-2">
          <b>Era:</b>
          <p className="ms-3">{dino.era}</p>
        </div>

        <div className="mb-2">
          <b>Dieta:</b>
          <p className="ms-3">{dino.diet}</p>
        </div>

        <div className="mb-2">
          <b>Descripción:</b>
          <p className="ms-3">{dino.description || "No hay descripción"}</p>
        </div>

        <div className="mb-3">
          <b>Paleontólogo:</b>
          <p className="ms-3">{dino.paleontologist?.name || "No asignado"}</p>
        </div>

        {/* Botones de admin SOLO si hay token */}
        {token && (
          <div className="d-flex justify-content-center gap-2 mt-3">
            <button className="btn btn-primary" onClick={handleEdit}>
              Editar
            </button>
          </div>
        )}

        {/* Confirmación de eliminación */}
        {token && showConfirm && (
          <div
            className="mt-4 p-3 border rounded bg-light text-center"
            style={{ boxShadow: "0 0 10px rgba(0,0,0,0.1)" }}
          >
            <p>¿Eliminar dinosaurio?</p>
            <div className="d-flex justify-content-center gap-3">
              <button className="btn btn-danger" onClick={handleDelete}>
                Sí
              </button>
              <button
                className="btn btn-secondary"
                onClick={() => setShowConfirm(false)}
              >
                No
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default DinoDetail;
